import axios from "axios";

const RAW = import.meta.env.VITE_API_URL || "/api/";
const API_BASE_URL = RAW.endsWith("/") ? RAW : RAW + "/";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// filet de sécurité si quelqu’un utilise axios() “nu”
axios.defaults.baseURL = API_BASE_URL;

// List of public endpoints that don't require auth
const PUBLIC_ENDPOINTS = ["applist/"];

// Add Authorization token if needed
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  const isPublic = PUBLIC_ENDPOINTS.some((endpoint) =>
    config.url.includes(endpoint)
  );

  if (token && !isPublic) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});

// Intercept 401 errors and try refresh
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshed = await refreshAccessToken();
      if (refreshed) {
        originalRequest.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
        return apiClient(originalRequest);
      } else {
        removeToken();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

// Manual token setter
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("accessToken", token);
  } else {
    localStorage.removeItem("accessToken");
  }
}

// Refresh token logic
async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return false;

    const response = await axios.post(`${API_BASE_URL}token/refresh/`, {
      refresh: refreshToken,
    });

    const { access } = response.data;
    setAuthToken(access);
    return true;
  } catch (error) {
    console.error("Token refresh failed", error);
    return false;
  }
}

// Remove both tokens
function removeToken() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}

// Example helper
export const PorteurJungo = async (id_jungo) => {
  try {
    const response = await apiClient.post("get_porteur/", {
      id_jungo,
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du porteur :", error);
    throw error;
  }
};

export default apiClient;
